import {useEffect, useState} from "react";
import {Skeleton} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
import ActionBar from "~/layout/ActionBar";
import Button from "~/components/Button";
import {TrainingReportSearch, TrainingReportSummary} from "../../components";
import {apiError, handleRequest} from "~/utils";
import {reportApi} from "~/api";
import {useGroup} from "~/hooks";

const STATUS_LABELS = {
	trained:     'Đã đào tạo',
	not_trained: 'Chưa đào tạo',
	upcoming:    'Sắp diễn ra',
	in_progress: 'Đang diễn ra',
	overdue:     'Quá giờ',
	postponed:   'Dời lịch',
	cancelled:   'Đã hủy',
};

function TrainingReport() {

	const listGroup = useGroup();

	const [items, setItems]     = useState({});
	const [loading, setLoading] = useState(false);

	const [filter, setFilter] = useState({
		startFrom: dayjs().startOf('month').unix(),
		startTo:   dayjs().endOf('month').unix(),
		trainerId: undefined,
		groupId:   undefined,
	});

	useEffect(() => { handleLoad(); }, [filter]);

	const handleLoad = async () => {
		setLoading(true);
		let [error, response] = await handleRequest(reportApi.training(filter));
		let message = apiError('Lấy thông tin báo cáo đào tạo thất bại', error, response);
		if (!message) setItems(response.data);
		setLoading(false);
	};

	const handleExport = () => {
		const statusData = [
			['Trạng thái', 'Số lượng'],
			...Object.entries(STATUS_LABELS).map(([key, label]) => [
				label,
				items.statusSummary?.[key] ?? 0,
			]),
		];
		const employeeData = [
			['STT', 'Nhân viên', 'Số buổi đã đào tạo'],
			...(items.trainerSummary || []).map((row, i) => [
				i + 1,
				row.trainer ? `${row.trainer.firstname} ${row.trainer.lastname}` : '—',
				row.trained ?? 0,
			]),
		];
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(statusData), 'Tổng quan');
		XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(employeeData), 'Theo nhân viên');
		const from = filter.startFrom ? dayjs.unix(filter.startFrom).format('DDMMYYYY') : '';
		const to   = filter.startTo   ? dayjs.unix(filter.startTo).format('DDMMYYYY')   : '';
		XLSX.writeFile(wb, `bao-cao-dao-tao-${from}-${to}.xlsx`);
	};

	return (
		<>
			<ActionBar title="Báo cáo đào tạo">
				<Button primary small leftIcon={<DownloadOutlined />} onClick={handleExport}>
					Xuất báo cáo
				</Button>
			</ActionBar>
			<div className="container">
				<div className="content pd-1 pdb-3">
					<TrainingReportSearch filter={filter} listGroup={listGroup} onChange={setFilter} />
					{loading && <Skeleton active style={{marginTop: 16}} />}
					{!loading && (
						<TrainingReportSummary
							statusSummary={items.statusSummary || {}}
							trainerSummary={items.trainerSummary || []}
						/>
					)}
				</div>
			</div>
		</>
	);
}

export default TrainingReport;
